export const ROLES = {
  operations: 'Operativo',
  manager: 'Administrador',
}
export const DEFAULT_ROLE = 'operations'
